{
  "enum": {
    "IxcSweepsV1CutoffSource": {
      "ASSET_EXCEPTION": "Asset Exception",
      "REGULAR": "Regular",
      "SESSION_DEFAULT": "Session Default",
      "SESSION_EXCEPTION": "Session Exception",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsV1SweepPlanStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcSweepsV1SweepTargetStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcSweepsV1SweepPlanQueryServiceSweepPlanListFilterableFields": {
      "status": "Status",
      "sweepPlanId": "Sweep Plan"
    },
    "IxcSweepsV1SweepTargetQueryServiceSweepTargetListFilterableFields": {
      "data": {
        "cusip": "CUSIP"
      },
      "status": "Status",
      "sweepTargetId": "Sweep Target"
    }
  },
  "oneOf": {
    "IxcSweepsV1SweepPlanEventType": {
      "archived": "Archived",
      "created": "Created",
      "updated": "Updated"
    },
    "IxcSweepsV1SweepTargetEventType": {
      "archived": "Archived",
      "created": "Created",
      "updated": "Updated"
    }
  },
  "searchEnum": {
    "IxcSweepsV1SweepPlanQueryServiceSweepPlanListSearchableFields": {
      "data": {
        "name": "Name"
      }
    },
    "IxcSweepsV1SweepTargetQueryServiceSweepTargetListSearchableFields": {
      "data": {
        "name": "Name",
        "symbol": {
          "base": "Symbol Base"
        }
      }
    }
  },
  "sortEnum": {
    "IxcSweepsV1SweepPlanQueryServiceSweepPlanListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcSweepsV1SweepTargetQueryServiceSweepTargetListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}